import React, {Component} from "react";
import DefaultModal from "../invoice/DefaultModal";
import {Alert as Alert2, Col, Input} from "reactstrap";
import ReactLoading from "react-loading";
import {request} from "../../helper/APIUtils";
import {deepCopyObject, hasUserRight, showAxiosError} from "../../helper/helper";
import Select from "../../local_node_modules/react-select";
import {Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle} from "react-accessible-accordion";
import moment from "moment/moment";
import Alert from "react-s-alert";
import {Decimal} from "decimal.js";
import {showConnectorPayment} from "../../helper/permission";
import {EntegratorConf} from "../../constants";
import {UserRightsEnum} from "../../helper/enums";


class ConnectorPaymentModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            modal: false,
            connectorPayments: [],
            connectorPaymentsPyld:
                {
                    recordId: null,
                    customerId: this.props.customer ? this.props.customer.recordId : this.props.currentUser.customerId,
                    customerBranchId: null,
                    erpType: null,
                    fatura: false,
                    faturaPrice: 0,
                    eirsaliye: false,
                    eirsaliyePrice: 0,
                    emm: false,
                    emmPrice: 0,
                    defter: false,
                    defterPrice: 0,
                    muhasebe: false,
                    sigorta: false,
                    sigortaPrice: 0,
                    muhasebePrice: 0,
                    installation: false,
                    installationPrice: 0,
                    updatedValue: false,
                    updatedValuePrice: 0,
                    smm: false,
                    smmPrice: 0
                },
            installationPaymentsPyld: [
                {
                    recordId:null,
                    customerId: this.props.customer ? this.props.customer.recordId : this.props.currentUser.customerId,
                    paymentStatus: 0,
                    connectorType:null,
                    branchId:null,
                    merchantOid: null,
                    servicePrice:0.00,
                    progressRate:0,
                    serviceType:null,
                    startDate: null,
                    expireDate: null
                }],
            total: 0,
            loading: false,
            page: 0,
            size: 10,
            currentBranch: null,
            erpTypeList: [],
            branchList: [],
            paymentInfo: {},
            faturaContract: false,
            earsivContract: false,
            eirsaliyeContract: false,
            emmContract: false,
            smmContract: false,
            defterContract: false,
            muhasebeContract: false,
            sigortaContract: false,
            updatedValueContract : false,
            updatedValue: false,
            updatedValuePrice: 0,
            tutarPrice: 0,
            fatura: false,
            faturaPrice: 0,
            eirsaliye: false,
            eirsaliyePrice: 0,
            emm: false,
            emmPrice: 0,
            smm: false,
            smmPrice: 0,
            defter: false,
            defterPrice: 0,
            muhasebe: false,
            muhasebePrice: 0,
            installation: false,
            installationPrice: 0,
            sigorta: false,
            sigortaPrice: 0,
            priceList: [],
            tolerateDay: 0,
            connectorNewPayments: [],
            installationPayments: [],
            installationPriceList: [],
            connectorBranchErpPylds: [],
            selectedBranchIds: [],
            connectorType: null,
            updatedPrice: 0
        }
        this.fetchData = this.fetchData.bind(this);
        this.removeLine = this.removeLine.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeCheck = this.onChangeCheck.bind(this);
        this.addPaymentLine = this.addPaymentLine.bind(this);
        this.getErpTypes = this.getErpTypes.bind(this);
        this.getErpType = this.getErpType.bind(this);
        this.getBranchName = this.getBranchName.bind(this);
        this.getTotalPrice = this.getTotalPrice.bind(this);
        this.getPayment = this.getPayment.bind(this);
        this.fetchConnectorPriceList = this.fetchConnectorPriceList.bind(this);
        this.fetchConnectorPriceListByErp = this.fetchConnectorPriceListByErp.bind(this);
        this.checkPaymentInfo = this.checkPaymentInfo.bind(this);
        this.filterConnectorPayments = this.filterConnectorPayments.bind(this);
        this.onSave = this.onSave.bind(this);
        this.checkBeforeSave = this.checkBeforeSave.bind(this);
    }

    async componentDidMount() {
        await this.getErpTypes();
        if(showConnectorPayment(EntegratorConf.identifier)){
            await this.fetchInstallationPrices();
            await this.fetchCustomerContracts();
        }
        if(hasUserRight(UserRightsEnum.ekonnektor.view,this.props.currentUser)){
            this.getConnectionInfo();
        }
        await this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size);
        await this.fetchConnectorPriceList();
    }

    getConnectionInfo = async()=>{
        let params = {
            url: `/connector/getConnectionInfo`,
            method: "post"
        };
        try{
            let {data} = await request(params);
            if(data!=null){
                let connectorType = data.erpType.groupType;
                let connectorTypeValue = connectorType === "ConnectorStandart" ? 1 : connectorType === "ConnectorPlus" ? 2 : null;
                const updatedValueService = this.state.installationPriceList.find(
                    item => item.serviceType === 7 && item.connectorType === connectorTypeValue
                );
                const updatedValuePrice = updatedValueService ? updatedValueService.servicePrice : null;
                this.setState(prevState => ({
                    connectorType:connectorTypeValue,
                    updatedPrice: updatedValuePrice,
                    connectorPaymentsPyld: {
                        ...prevState.connectorPaymentsPyld,
                        erpType: connectorTypeValue,
                        customerBranchId: data.branchId
                    }
                }));
            }
        }catch(error){
            let err = {response:{data:"Konnektör Bulunamadı"}}
            showAxiosError(err);
        }
    }

    async fetchData(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '';
        let customerId = self.props.currentUser ? self.props.currentUser.customerId : 0;
        let params = {
            url: '/connector/fetchAllConnectorPayment?page=' + page + '&size=' + size + sortStr + '&id=' + customerId,
            method: "post"
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual});
        try {
            const response = await request(params);
            let activeBranchIndex = this.props.connectionInfo.branchId;
            let branchList = Object.entries(response.data.branchList).map(([key, value]) => ({
                value: key,
                label: value
            }));

            let connectorPayments = response.data.connectorPayments.content;
            let installationPayments = response.data.installationPrices;
            let connectorNewPayments = response.data.connectorNewPayments;

            let isPaymentActive = ((typeof (connectorPayments.find(item => item.connectorNewPaymentId === null))) === "object" ||
                (typeof (connectorNewPayments.find(item => (item.paymentStatus == 0 || item.paymentStatus == 3)))) === "object");

            let result = branchList.find(item => item.value == activeBranchIndex);
            let currentBranch = result ? result : branchList[0];

            if (this.props.checkConnectorUpdated === true){
                self.setState({updatedValueContract: true})
            }

            self.setState({
                page: page,
                size: size,
                total: response.data.connectorPayments.totalElements,
                connectorPayments,
                activeBranchIndex,
                currentBranch,
                loading: false,
                isPaymentActive,
                connectorNewPayments,
                installationPayments: installationPayments
            });
        } catch (error) {
            self.setState({ loading: false });
            showAxiosError(error);
        }
    }

    async fetchInstallationPrices() {
        let self = this;
        let customerId = this.props.currentUser && this.props.currentUser.parentCustomerId !== null ? this.props.currentUser.parentCustomerId : 1;
        let url =  `/list-price/fetchInstallationPriceList/${customerId}`;
        let installationPriceList = [];
        let params = {
            url: url,
            method: "get",
        };
        self.setState({isLoading: true});
        return request(params)
            .then(function (response) {
                installationPriceList = response.data;
                for(let i=0; i < installationPriceList.length;i++){
                    installationPriceList[i]["startDate"] = moment(installationPriceList[i]["startDate"]).format("YYYY-MM-DD");
                    installationPriceList[i]["expireDate"] = moment(installationPriceList[i]["expireDate"]).format("YYYY-MM-DD");
                }
                self.setState({
                    isLoading: false,
                    installationPriceList: installationPriceList
                })
                return Promise.resolve(response.data);
            }).catch(function (error) {
                showAxiosError(error);
                self.setState({ isLoading: false})
                return Promise.resolve(installationPriceList);
            });
    }

    async fetchCustomerContracts() {
        let customerId = this.props.customer ? this.props.customer.recordId : this.props.currentUser.customerId;
        let page = this.props.page;
        let branchId = this.props.connectionInfo.branchId;
        let url = `/customer/customerContracts/${customerId}/${branchId}`;
        let params = {
            url: url,
            method: "get",
        };

        this.setState({ isLoading: true });

        try {
            const response = await request(params);
            const data = response.data;

            if (this.props.propType){
                for (let i = 0; i < this.props.propType.length; i++) {
                    if (this.props.propType[i] != null && this.props.propType[i] === "earsiv"){
                        this.setState({earsivContract: data.some(contract => contract.service.recordId === 1)})
                    }
                    if (this.props.propType[i] != null && this.props.propType[i] === "fatura"){
                        this.setState({faturaContract: data.some(contract => contract.service.recordId === 2)})
                    }
                    else if (this.props.propType[i] != null && this.props.propType[i] === "defter"){
                        this.setState({defterContract: data.some(contract => contract.service.recordId === 3)})
                    }
                    else if (this.props.propType[i] != null && this.props.propType[i] === "muhasebe"){
                        this.setState({muhasebeContract: data.some(contract => contract.service.recordId === 4)})
                    }
                    else if (this.props.propType[i] != null && this.props.propType[i] === "eirsaliye"){
                        this.setState({eirsaliyeContract: data.some(contract => contract.service.recordId === 6)})
                    }
                    else if (this.props.propType[i] != null && this.props.propType[i] === "emm"){
                        this.setState({emmContract: data.some(contract => contract.service.recordId === 8)})
                    }
                    else if (this.props.propType[i] != null && this.props.propType[i] === "smm"){
                        this.setState({smmContract: data.some(contract => contract.service.recordId === 7)})
                    }
                    else if (this.props.propType[i] != null && this.props.propType[i] === "sigorta"){
                        this.setState({sigortaContract: data.some(contract => contract.service.recordId === 125)})
                    }
                }
            }
        } catch (error) {
            showAxiosError(error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    async getTotalPrice() {
        let tutarPrice = new Decimal(0);
        let checkInstallationPrice = await this.checkInstallationPrice();
        if (!checkInstallationPrice && (this.props.checkConnectorInstallation === true) && (this.state.connectorPaymentsPyld.fatura || this.state.connectorPaymentsPyld.defter ||
            this.state.connectorPaymentsPyld.eirsaliye || this.state.connectorPaymentsPyld.emm || this.state.connectorPaymentsPyld.smm || this.state.connectorPaymentsPyld.muhasebe)) {
            const installationService = this.state.installationPriceList.find(
                item => item.serviceType === 6 && item.connectorType === this.state.connectorType
            );
            const installationPrice = installationService ? installationService.servicePrice : null;
            this.setState(prevState => ({
                installation: true,
                installationPrice: installationPrice,
                connectorPaymentsPyld: {
                    ...prevState.connectorPaymentsPyld,
                    installation: true,
                    installationPrice: installationPrice
                }
            }));
        }else{
            this.setState(prevState => ({
                installation: false,
                installationPrice: 0,
                connectorPaymentsPyld: {
                    ...prevState.connectorPaymentsPyld,
                    installation: false,
                    installationPrice: 0
                }
            }));
        }
        if (this.state.fatura) {
            tutarPrice = tutarPrice.add(new Decimal(this.state.faturaPrice));
        }

        if (this.state.defter) {
            tutarPrice = tutarPrice.add(new Decimal(this.state.defterPrice));
        }

        if (this.state.eirsaliye) {
            tutarPrice = tutarPrice.add(new Decimal(this.state.eirsaliyePrice));
        }

        if (this.state.emm) {
            tutarPrice = tutarPrice.add(new Decimal(this.state.emmPrice));
        }

        if (this.state.smm) {
            tutarPrice = tutarPrice.add(new Decimal(this.state.smmPrice));
        }

        if (this.state.muhasebe) {
            tutarPrice = tutarPrice.add(new Decimal(this.state.muhasebePrice));
        }

        if (this.state.installation) {
            tutarPrice = tutarPrice.add(new Decimal(this.state.installationPrice));
        }

        if (this.state.sigorta) {
            tutarPrice = tutarPrice.add(new Decimal(this.state.sigortaPrice));
        }

        if (this.state.updatedValue) {
            tutarPrice = tutarPrice.add(new Decimal(this.state.updatedValuePrice));
        }

        this.setState({ tutarPrice: tutarPrice.toFixed(4) });
    }

    removeLine(item, index) {
        let installationPayments = deepCopyObject(this.state.installationPaymentsPyld);
        let selectedBranchIds = deepCopyObject(this.state.selectedBranchIds);
        const indexOfValue = selectedBranchIds.findIndex(i => i.value === item.branchId);
        if (indexOfValue !== -1) {
            selectedBranchIds.splice(indexOfValue, 1);
        }
        installationPayments.splice(index, 1);
        this.setState({installationPaymentsPyld: installationPayments, selectedBranchIds});

    }

    onChange(e, index) {
        let installationPayments = deepCopyObject(this.state.installationPaymentsPyld);
        let connectorPayments = deepCopyObject(this.state.connectorPaymentsPyld);
        let priceLists = deepCopyObject(this.state.priceList);
        let connectorBranchErpPylds = this.state.connectorBranchErpPylds;
        let selectedBranchIds = [{index: index, value: e.value}]
        installationPayments[index][e.name] = e.value;
        connectorPayments[index].customerBranchId = e.value;


        if (e.name == "branchId") {
            let indexOfValue = selectedBranchIds.findIndex(i => i.index === index);
            if (indexOfValue === -1) {
                selectedBranchIds.push({index: index, value: e.value});
            } else {
                selectedBranchIds.splice(indexOfValue, 1);
                selectedBranchIds.push({index: index, value: e.value});
                this.setState({
                    fatura: false,
                    faturaPrice: 0,
                    eirsaliye: false,
                    eirsaliyePrice: 0,
                    emm: false,
                    emmPrice: 0,
                    smm: false,
                    smmPrice: 0,
                    defter: false,
                    defterPrice: 0,
                    muhasebe: false,
                    muhasebePrice: 0,
                    installation: false,
                    installationPrice: 0,
                    sigorta: false,
                    sigortaPrice: 0,
                })
            }
            let serviceType = connectorBranchErpPylds.find(o => e.value == o.branchId) ? connectorBranchErpPylds.find(o => e.value == o.branchId).erpId : null;
            let connectorType = priceLists.find(o => e.value == o.branchId) ? priceLists.find(o => e.value == o.branchId).connectorType : null;
            installationPayments[index].serviceType = serviceType;
            connectorPayments[index].erpType = connectorType;
            if (connectorType === 1){
                installationPayments[index].connectorType = 1 ;
            }
            if (connectorType === 2){
                installationPayments[index].connectorType = 2 ;
            }
            for (let i = 0; i < priceLists.length; i++) {
                if (priceLists[i].serviceType !== null){
                    if (priceLists[i].serviceType === 1 && priceLists[i].branchId === e.value && priceLists[i].paymentStatus !== 2){
                        this.fetchConnectorPriceListByErp(true, e.value, 1, "fatura", connectorPayments[index]);
                    }
                    if (priceLists[i].serviceType === 3 && priceLists[i].branchId === e.value && priceLists[i].paymentStatus !== 2){
                        this.fetchConnectorPriceListByErp(true, e.value, 3, "defter", connectorPayments[index]);
                    }
                    if (priceLists[i].serviceType === 6 && priceLists[i].branchId === e.value && priceLists[i].paymentStatus !== 2){
                        this.fetchConnectorPriceListByErp(true, e.value, 6, "eirsaliye", connectorPayments[index]);
                    }
                    if (priceLists[i].serviceType === 8 && priceLists[i].branchId === e.value && priceLists[i].paymentStatus !== 2){
                        this.fetchConnectorPriceListByErp(true, e.value, 8, "emm", connectorPayments[index]);
                    }
                    if (priceLists[i].serviceType === 7 && priceLists[i].branchId === e.value && priceLists[i].paymentStatus !== 2){
                        this.fetchConnectorPriceListByErp(true, e.value, 7, "smm", connectorPayments[index]);
                    }
                    if (priceLists[i].serviceType === 12 && priceLists[i].branchId === e.value && priceLists[i].paymentStatus !== 2){
                        this.fetchConnectorPriceListByErp(true, e.value, 12, "emuhasebe", connectorPayments[index]);
                    }
                    if (priceLists[i].serviceType === 13 && priceLists[i].branchId === e.value && priceLists[i].paymentStatus !== 2){
                        this.fetchConnectorPriceListByErp(true, e.value, 13, "installation", connectorPayments[index], connectorType);
                    }
                    if (priceLists[i].serviceType === 125 && priceLists[i].branchId === e.value && priceLists[i].paymentStatus !== 2){
                        this.fetchConnectorPriceListByErp(true, e.value, 125, "sigorta", connectorPayments[index]);
                    }

                }
            }
        }
        this.setState({selectedBranchIds: selectedBranchIds, installationPaymentsPyld: installationPayments, connectorPaymentsPyld: connectorPayments});
    }

    async onChangeCheck(value, name) {
        let result = "0";
        let newState = {};

        if (name == "fatura") {
            const faturaService = this.state.installationPriceList.find(
                item => item.serviceType === 1 && item.connectorType === this.state.connectorType
            );
            const faturaPrice = faturaService ? faturaService.servicePrice : null;
            this.setState(prevState => ({
                fatura: value,
                faturaPrice: faturaPrice,
                connectorPaymentsPyld: {
                    ...prevState.connectorPaymentsPyld,
                    fatura: value,
                    faturaPrice: faturaPrice
                }
            }));
        }
        if (name == "eirsaliye") {
            const eirsaliyeService = this.state.installationPriceList.find(
                item => item.serviceType === 2 && item.connectorType === this.state.connectorType
            );
            const eirsaliyePrice = eirsaliyeService ? eirsaliyeService.servicePrice : null;
            this.setState(prevState => ({
                eirsaliye: value,
                eirsaliyePrice: eirsaliyePrice,
                connectorPaymentsPyld: {
                    ...prevState.connectorPaymentsPyld,
                    eirsaliye: value,
                    eirsaliyePrice: eirsaliyePrice
                }
            }));
        }
        if (name == "emm") {
            const emmService = this.state.installationPriceList.find(
                item => item.serviceType === 3 && item.connectorType === this.state.connectorType
            );
            const emmPrice = emmService ? emmService.servicePrice : null;
            this.setState(prevState => ({
                emm: value,
                emmPrice: emmPrice,
                connectorPaymentsPyld: {
                    ...prevState.connectorPaymentsPyld,
                    emm: value,
                    emmPrice: emmPrice
                }
            }));
        }
        if (name == "smm") {
            const smmService = this.state.installationPriceList.find(
                item => item.serviceType === 8 && item.connectorType === this.state.connectorType
            );
            const smmPrice = smmService ? smmService.servicePrice : null;
            this.setState(prevState => ({
                smm: value,
                smmPrice: smmPrice,
                connectorPaymentsPyld: {
                    ...prevState.connectorPaymentsPyld,
                    smm: value,
                    smmPrice: smmPrice
                }
            }));
        }
        if (name == "sigorta") {
            const sigortaService = this.state.installationPriceList.find(
                item => item.serviceType === 125 && item.connectorType === this.state.connectorType
            );
            const sigortaPrice = sigortaService ? sigortaService.servicePrice : null;
            this.setState(prevState => ({
                sigorta: value,
                sigortaPrice: sigortaPrice,
                connectorPaymentsPyld: {
                    ...prevState.connectorPaymentsPyld,
                    sigorta: value,
                    sigortaPrice: sigortaPrice
                }
            }));
        }
        if (name == "defter") {
            const defterService = this.state.installationPriceList.find(
                item => item.serviceType === 4 && item.connectorType === this.state.connectorType
            );
            const defterPrice = defterService ? defterService.servicePrice : null;
            this.setState(prevState => ({
                defter: value,
                defterPrice: defterPrice,
                connectorPaymentsPyld: {
                    ...prevState.connectorPaymentsPyld,
                    defter: value,
                    defterPrice: defterPrice
                }
            }));
        }
        if (name == "muhasebe") {
            const muhasebeService = this.state.installationPriceList.find(
                item => item.serviceType === 5 && item.connectorType === this.state.connectorType
            );
            const muhasebePrice = muhasebeService ? muhasebeService.servicePrice : null;
            this.setState(prevState => ({
                muhasebe: value,
                muhasebePrice: muhasebePrice,
                connectorPaymentsPyld: {
                    ...prevState.connectorPaymentsPyld,
                    muhasebe: value,
                    muhasebePrice: muhasebePrice
                }
            }));
        }
        if (name == "updatedValue") {
            const updatedValueService = this.state.installationPriceList.find(
                item => item.serviceType === 7 && item.connectorType === this.state.connectorType
            );
            const updatedValuePrice = updatedValueService ? updatedValueService.servicePrice : null;
            this.setState(prevState => ({
                updatedValue: value,
                updatedValuePrice: updatedValuePrice,
                connectorPaymentsPyld: {
                    ...prevState.connectorPaymentsPyld,
                    updatedValue: value,
                    updatedValuePrice: updatedValuePrice
                }
            }));
        }

        this.setState(newState, () => this.getTotalPrice());
    }

    addPaymentLine() {
        let installationPayments = deepCopyObject(this.state.installationPaymentsPyld);
        installationPayments.push(
            {
                recordId:null,
                customerId: this.props.customer ? this.props.customer.recordId : this.props.currentUser.customerId,
                connectorType:null,
                branchId:null,
                serviceType:null,
                servicePrice:0.00,
                progressRate:0,
                startDate: null,
                expireDate: null
            }
        );
        this.setState({installationPaymentsPyld: installationPayments});
    }

    async checkInstallationPrice() {
        let customerId = this.props.customer ? this.props.customer.recordId : this.props.currentUser.customerId;
        let branchId = this.props.connectionInfo.branchId;
        let params = {
            url: `/connector/checkInstallationPrice/${customerId}/${branchId}`,
            method: "get",
        };
        try {
            const response = await request(params);
            return response.data;
        } catch (error) {
            showAxiosError(error);
        }
    }


    async getErpTypes() {
        let erpTypeList = [];
        let branchList = [];
        let connectorBranchErpPylds = [];
        let customerId = this.props.customer ? this.props.customer.recordId : this.props.currentUser.customerId;
        let params = {
            url: `/connector/fetchConnectorPriceByErpType/${customerId}`,
            method: "get",
        };
        request(params).then(response => {
            if (response.data) {

                if (response.data.connectorBranchErpPylds) {
                    connectorBranchErpPylds = response.data.connectorBranchErpPylds;
                    branchList = connectorBranchErpPylds.map(data => ({value: data.branchId, label: data.branchName}));
                }
                if (response.data.erpTypeList) {
                    response.data.erpTypeList.map(data => {
                        erpTypeList.push({value: data[0], label: data[1]});
                    });
                }
            }
            this.setState({erpTypeList, branchList, connectorBranchErpPylds});
        }).catch(error => {
            showAxiosError(error);
        });
    }

    getErpType(value) {
        let erpLabel = null;
        erpLabel = this.state.erpTypeList.find(item => item.value === value);
        return erpLabel
    }

    getBranchName(value) {
        let branchLabel = null;
        let connectorBranchErpPylds = this.state.connectorBranchErpPylds;
        branchLabel = connectorBranchErpPylds.find(item => item.branchId == value);
        return branchLabel ? { value: branchLabel.erpId, label: branchLabel.branchName } : null;
    }

    getConnectorType(value) {
        if (value === 1){
            return { value: 0, label: "Connector Standart" }
        }
        if (value === 2){
            return { value: 1, label: "Connector Plus" }
        }
    }

    checkPaymentInfo() {
        let customerId = this.props.currentUser ? this.props.currentUser.customerId : 0;
        return new Promise((resolve) => {
            let params = {
                url: `/connector/checkPaymentInfo/${customerId}`,
                method: "post"
            };
            request(params).then((response) => {
                var result = response.data;
                resolve(result);
            })
        })
    }

    async getPayment() {
        let merchantOkUrl = window.location.origin;
        let self = this;
        self.setState({loading: true});
        let result = await self.onSave();
        if (result) {
            let recordId = await self.checkPaymentInfo();
            let expireDate = this.props.expireDate ? this.props.expireDate : null;
            let params = {
                url: "/connector/setConnectorPaymentInfo",
                method: "post",
                data: {
                    merchantOkUrl: merchantOkUrl,
                    recordId: recordId,
                    expireDate: expireDate
                }
            };
            request(params)
                .then(function (response) {
                    let paymentData = response.data;
                    Alert.success("Sepete eklendi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000,
                        html: false
                    });
                    setTimeout(function () {
                        self.setState({loading: false});
                        window.location.href = self.props.currentUser.paytrDomain + "/external/" + paymentData.merchantOid;
                    }, 100);
                }).catch(function (error) {
                self.setState({loading: false});
                showAxiosError(error);
            });
        }else{
            self.setState({loading: false});
        }
    }


    async fetchConnectorPriceList() {
        let customerId = this.props.currentUser ? this.props.currentUser.customerId : 0;
        let params = {
            url: `/connector/fetchConnectorPriceList/${customerId}`,
            method: "get"
        };
        await request(params)
            .then(response => {
                let data = response.data;
                this.setState({priceList: data})
            })
            .catch(function (error) {
                showAxiosError(error);
            });
    }


    fetchConnectorPriceListByErp(isActive, erpType, serviceType, serviceName, connectorPayments, connectorType) {
        let priceList = deepCopyObject(this.state.priceList);
        let data = [];
        data = priceList.filter(i => i.branchId == erpType && i.serviceType == serviceType);
        let options = data.map(i => {
                return i.servicePrice
            }
        );
        let price = isActive ? ((options !== null && options !== [] && options !== undefined) ? (!!options[0] ? options[0] : "0") : "0") : "0";
        this.fetchServiceNameAndPrice(price, serviceType, serviceName, connectorPayments, isActive, connectorType);
        return price;
    }

    fetchServiceNameAndPrice(price, serviceType, serviceName, connectorPayments, isActive, connectorType) {
        if (serviceName === "fatura"){
            this.setState({ faturaPrice: price})
            connectorPayments[serviceName] = isActive;
            connectorPayments[serviceName + 'Price'] = price;
            this.onChangeCheck(serviceName, true);
        }
        if (serviceName === "defter"){
            this.setState({ defterPrice: price})
            connectorPayments[serviceName] = isActive;
            connectorPayments[serviceName + 'Price'] = price;
            this.onChangeCheck(serviceName, true);
        }
        if (serviceName === "eirsaliye"){
            this.setState({ eirsaliyePrice: price})
            connectorPayments[serviceName] = isActive;
            connectorPayments[serviceName + 'Price'] = price;
            this.onChangeCheck(serviceName, true);
        }
        if (serviceName === "emm"){
            this.setState({ emmPrice: price})
            connectorPayments[serviceName] = isActive;
            connectorPayments[serviceName + 'Price'] = price;
            this.onChangeCheck(serviceName, true);
        }
        if (serviceName === "sigorta"){
            this.setState({ sigortaPrice: price})
            connectorPayments[serviceName] = isActive;
            connectorPayments[serviceName + 'Price'] = price;
            this.onChangeCheck(serviceName, true);
        }
        if (serviceName === "smm"){
            this.setState({ smmPrice: price})
            connectorPayments[serviceName] = isActive;
            connectorPayments[serviceName + 'Price'] = price;
            this.onChangeCheck(serviceName, true);
        }
        if (serviceName === "emuhasebe"){
            this.setState({ emuhasebePrice: price})
            connectorPayments[serviceName] = isActive;
            connectorPayments[serviceName + 'Price'] = price;
            this.onChangeCheck(serviceName, true);
        }
        if (serviceName === "installation"){
            let backup = this.getExistingInstallationPrice(connectorType,serviceType);
            if (backup !== null){
                this.setState({ installationPrice: 1150})
                connectorPayments[serviceName] = isActive;
                connectorPayments[serviceName + 'Price'] = 1150;
                this.onChangeCheck(serviceName, true);
            }else{
                this.setState({ installationPrice: price})
                connectorPayments[serviceName] = isActive;
                connectorPayments[serviceName + 'Price'] = price;
                this.onChangeCheck(serviceName, true);
            }

        }
    }

    getExistingInstallationPrice(connectorType,serviceType) {
        let result = null;
        let customerId = this.props.customer ? this.props.customer.recordId : this.props.currentUser.customerId;
        let data = {
            customerId: customerId,
            connectorType: connectorType,
            serviceType: serviceType
        }
        let params = {
            url: '/connector/getExistingInstallationPrice',
            method: "get",
            data: data
        };
        request(params).then((response) => {
            let result = response.data;
        })
        return result;
    }

    getStatusText(item) {
        let result = "";
        let status = item.paymentStatus;
        switch (status) {
            case 0:
                result = <label style={{fontWeight: 'bold'}}><a
                    href={this.props.currentUser.paytrDomain + "/external/" + item.merchantOid}>{item.paymentExplanation}</a></label>;
                break;
            case 1:
                result = <label style={{color: 'black', fontWeight: 'bold'}}>{item.paymentExplanation}</label>;
                break;
            case 2:
                result = <label style={{
                    color: '#3d7c47',
                    fontWeight: 'bold'
                }}>{item.paymentExplanation} {item.updatedAt ? this.modifyDate(item.updatedAt) : this.modifyDate(item.createdAt)}</label>;
                break;
            case 3:
                result = <label style={{color: '#E5310A', fontWeight: 'bold'}}>{item.paymentExplanation}</label>;
                break;
            default:
                result = <label style={{color: '#D6DBDF', fontWeight: 'bold'}}>{item.paymentExplanation}</label>;
                break;
        }
        return result;
    }

    getStatusColor(status) {
        let color = "";
        switch (status) {
            case 0:
                color = "#FF5733";
                break;
            case 1:
                color = "#101357";
                break;
            case 2:
                color = "#3d7c47";
                break;
            case 3:
                color = "#E5310A";
                break;
            default:
                color = "";
                break;
        }
        return color;
    }

    modifyDate(date) {
        return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }

    async onSave() {
        let connectorPayments = deepCopyObject(this.state.connectorPaymentsPyld);
        let checkIfNull = this.checkBeforeSave();
        if (checkIfNull) {
            Alert.error('En az bir hizmet fiyatı girilmiş olmalı!', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
            return false;
        } else {
            return new Promise((resolve) => {
            let params = {
                url: '/connector/saveConnectorPayment',
                method: "post",
                data: connectorPayments
            }
            request(params).then((response) => {
                let result = response.data;
                resolve(result);
            }).catch((err) => {
                showAxiosError(err);
            })
        })
        }
    }

    checkBeforeSave() {
        let checkIfNull = false;
        if (this.state.fatura === false && this.state.sigorta === false && this.state.eirsaliye === false && this.state.emm === false && this.state.smm === false && this.state.defter === false && this.state.muhasebe === false && this.state.updatedValueContract === false) {
            checkIfNull = true;
        }
        return checkIfNull;
    }

    filterConnectorPayments = (item) => {
        let checkIfExist = this.state.connectorNewPayments.find((i, index) => i.recordId === item.connectorNewPaymentId);

        if (checkIfExist != null) {
            let expirationDate = moment(checkIfExist.expireDate).valueOf();
            let now = moment().valueOf();

            let msToExpiration = expirationDate - now;

            if (msToExpiration < 0) {
                return "#ff8c8c";
            } else if (msToExpiration > 0 && checkIfExist.paymentStatus == 2) {
                return "#ffd86b";
            } else {
                return ""
            }
        } else {
            return "";
        }
    }

    paymentAlertColor(item) {
        if (item != null) {
            let expirationDate = moment(item.expireDate).valueOf();
            let now = moment().valueOf();
            let msToExpiration = expirationDate - now;
            if (msToExpiration < 0) {
                return "#f8d7da";
            } else if (msToExpiration > 0 && item.paymentStatus == 2) {
                return "#d4edda";
            } else {
                return "#fff3cd"
            }
        } else {
            return "#fff3cd";
        }
    }

    getEFaturaEarsivHeader = () => {
        if (this.state.faturaContract && this.state.earsivContract) {
            return <th width="8%">E-Fatura / E-Arşiv</th>;
        }
        if (this.state.faturaContract) {
            return <th width="8%">E-Fatura</th>;
        }
        if (this.state.earsivContract) {
            return <th width="8%">E-Arşiv</th>;
        }
        return null;
    };

    render() {
        let activeBranchIndex = this.state.activeBranchIndex;
        let tutarPrice = new Decimal(this.state.tutarPrice).toFixed(2);
        let tutarWithKdv = new Decimal(this.state.tutarPrice).add(new Decimal(this.state.tutarPrice).mul(new Decimal(0.20)).toFixed(2)).toFixed(2);
        let connectorPayments = this.state.connectorPayments;
        const connectorType = [
            { value: 1 , label: "Connector Standart"},
            { value: 2 , label: "Connector Plus"}
        ];
        return (
            <DefaultModal
                disabled={this.state.saveLoading}
                isOpen={this.props.modal}
                title="Konnektör Talep Takibi"
                size="xxl"
                confirmBtnText=""
                cancelBtnText="Kapat"
                onCancel={() => this.props.toggle(false)}>
                <Col sm="12">
                    <div sm="12" style={{border: "2px solid #e7e7e7", borderRadius: "6px 6px 6px 6px"}}>
                        <div className="card-body" style={{padding: '1em 1em 1em 1em'}}>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center'
                                    }}>
                                    </div>
                                </div>
                                <div className="col-sm-12" style={{paddingTop: '15px'}}>
                                    {/*<button type="button" className="Btn ekle"*/}
                                    {/*        style={{margin: "1", background: '#3fb0ac', float: 'right'}}*/}
                                    {/*        onClick={() => this.addPaymentLine()}>*/}
                                    {/*</button>*/}
                                </div>
                                <div className="col-sm-12">
                                    <table className="" style={{textAlign: 'center'}}>
                                        <thead>
                                        <tr style={{backgroundColor: '#ebedf0'}}>
                                            <th width="2%">#</th>
                                            <th width="16%">Şube Adı</th>
                                            <th width="16%">Konnektör Türü</th>
                                            {this.getEFaturaEarsivHeader()}
                                            { this.state.eirsaliyeContract && <th width="8%">E-Irsaliye</th>}
                                            { this.state.emmContract && <th width="8%">E-MM</th>}
                                            { this.state.smmContract && <th width="8%">SMM</th>}
                                            { this.state.defterContract && <th width="8%">E-Defter</th>}
                                            { this.state.muhasebeContract && <th width="8%">E-Muhasebe</th>}
                                            { this.state.sigortaContract && <th width="8%">E-Sigorta</th>}
                                            { this.state.updatedValueContract && <th width="8%">Güncelleme Ücreti</th>}
                                            { this.state.updatedValueContract && <th width="8%">Güncelleme Ücreti Fiyatı</th>}
                                            <th width="4%">İşlemler</th>
                                        </tr>
                                        </thead>

                                        {this.state.loading ?
                                            <tbody>
                                            <tr>
                                                <td colSpan="12">
                                                    <ReactLoading type="spinningBubbles" style={{
                                                        width: "70px",
                                                        height: "70px",
                                                        margin: "20px auto 0 auto",
                                                        fill: "#888"
                                                    }}/>
                                                </td>
                                            </tr>
                                            </tbody>
                                            :
                                            <tbody>
                                            {this.state.installationPaymentsPyld.map((item, index) =>
                                                <tr key={"connectorPayment" + index} className={""}
                                                    style={{backgroundColor: this.filterConnectorPayments(item)}}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                                            <Select name={"branchName"}
                                                                    value={this.getBranchName(activeBranchIndex)}
                                                                    clearable={false}
                                                                    disabled={true}
                                                                    noResultsText='Sonuç bulunmadı'
                                                                    placeholder="Şube Seçiniz..."
                                                                    style={{width: "115px"}}
                                                                    onChange={(e) =>
                                                                        this.onChange({
                                                                            value: e.value,
                                                                            name: "branchId"
                                                                        }, index)}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                                            <Select id={'connectorType_' + index}
                                                                    name={"connectorType"}
                                                                    disabled={true}
                                                                    value={this.getConnectorType(this.state.connectorType)}
                                                                    clearable={false}
                                                                    noResultsText="Sonuç bulunmadı"
                                                                    placeholder="Konnektör Türü Seçiniz..."
                                                                    style={{width: "165px"}}
                                                                    ref={'connectorType_' + index}
                                                                    onChange={(e) => this.onChange({
                                                                        value: e.value,
                                                                        name: "connectorType"
                                                                    }, index)}
                                                                    />
                                                        </div>
                                                    </td>
                                                    {(this.state.faturaContract || this.state.earsivContract) &&
                                                        <td>
                                                            <Input type="checkbox"
                                                                   id="fatura"
                                                                   disabled={false}
                                                                   name={"fatura"}
                                                                   bsSize={"15px"}
                                                                   style={{margin: "8px"}}
                                                                   checked={this.state.fatura}
                                                                   onChange={(e) => this.onChangeCheck(e.target.checked, e.target.name)}/>
                                                        </td>
                                                    }
                                                    {this.state.eirsaliyeContract &&
                                                        <td>
                                                            <Input type="checkbox"
                                                                   id="eirsaliye"
                                                                   name={"eirsaliye"}
                                                                   disabled={false}
                                                                   bsSize={"15px"}
                                                                   style={{margin: "8px"}}
                                                                   checked={this.state.eirsaliye}
                                                                   onChange={(e) => this.onChangeCheck(e.target.checked, e.target.name)}/>
                                                        </td>
                                                    }
                                                    {this.state.emmContract &&
                                                        <td>
                                                            <Input type="checkbox"
                                                                   id="emm"
                                                                   name={"emm"}
                                                                   disabled={false}
                                                                   bsSize={"15px"}
                                                                   style={{margin: "8px"}}
                                                                   checked={this.state.emm}
                                                                   onChange={(e) => this.onChangeCheck(e.target.checked, e.target.name)}/>
                                                        </td>
                                                    }
                                                    {(this.state.smmContract) && (
                                                        <td>
                                                            <Input type="checkbox"
                                                                   id="smm"
                                                                   name={"smm"}
                                                                   disabled={false}
                                                                   bsSize={"15px"}
                                                                   style={{margin: "8px"}}
                                                                   checked={this.state.smm}
                                                                   onChange={(e) => this.onChangeCheck(e.target.checked, e.target.name)}/>
                                                        </td>
                                                    )}
                                                    {this.state.defterContract &&
                                                        <td>
                                                            <Input type="checkbox"
                                                                   id="defter"
                                                                   name={"defter"}
                                                                   disabled={false}
                                                                   bsSize={"15px"}
                                                                   style={{margin: "8px"}}
                                                                   checked={this.state.defter}
                                                                   onChange={(e) => this.onChangeCheck(e.target.checked, e.target.name)}/>
                                                        </td>
                                                    }
                                                    {this.state.muhasebeContract &&
                                                        <td>
                                                            <Input type="checkbox"
                                                                   id="muhasebe"
                                                                   name={"muhasebe"}
                                                                   disabled={false}
                                                                   bsSize={"15px"}
                                                                   style={{margin: "8px"}}
                                                                   checked={this.state.muhasebe}
                                                                   onChange={(e) => this.onChangeCheck(e.target.checked, e.target.name)}/>
                                                        </td>
                                                    }
                                                    {this.state.sigortaContract &&
                                                        <td>
                                                            <Input type="checkbox"
                                                                   id="sigorta"
                                                                   name={"sigorta"}
                                                                   disabled={false}
                                                                   bsSize={"15px"}
                                                                   style={{margin: "8px"}}
                                                                   checked={this.state.sigorta}
                                                                   onChange={(e) => this.onChangeCheck(e.target.checked, e.target.name)}/>
                                                        </td>
                                                    }
                                                    {this.state.updatedValueContract &&
                                                        <td>
                                                            <input type="checkbox"
                                                                   id="updatedValue"
                                                                   name={"updatedValue"}
                                                                   disabled={false}
                                                                   bssize={"12px"}
                                                                   style={{margin: "8px"}}
                                                                   checked={this.state.updatedValue}
                                                                   onChange={(e) => this.onChangeCheck(e.target.checked, e.target.name)}/>
                                                        </td>
                                                    }
                                                    {this.state.updatedValueContract &&
                                                        <td>
                                                            <div style={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                width: "100%"
                                                            }}>
                                                                <Input type="text"
                                                                       id="updatedValuePrice"
                                                                       name={"updatedValuePrice"}
                                                                       value={this.state.updatedPrice + " ₺"}
                                                                       disabled={true}
                                                                       bssize={"12px"}
                                                                       style={{
                                                                           borderRadius: '5px',
                                                                           textAlign: 'center',
                                                                           padding: '8px',
                                                                           fontSize: '13px',
                                                                           width: '150px'
                                                                       }}
                                                                />
                                                            </div>
                                                        </td>
                                                    }
                                                    <td>
                                                        {this.state.installationPaymentsPyld.length > 1 && !item.branchId &&
                                                            <button type="button" className="Btn temizle"
                                                                    style={{margin: "0", background: '#FFCCCC'}}
                                                                    onClick={() => this.removeLine(item, index)}>
                                                            </button>
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                            }
                                            </tbody>
                                        }
                                    </table>
                                </div>
                                <Col sm="12">
                                    <p style={{float: "right"}}>Toplam Tutar: {tutarPrice} ₺ + KDV (%20)
                                        : {tutarWithKdv} ₺</p>
                                </Col>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <button type="button" data-toggle="tooltip" data-placement="bottom"
                                            style={{background: 'rgb(52, 216, 103)'}}
                                            disabled={this.state.loading || tutarPrice <= 0}
                                            rel="tooltip" className="TekBtn credit float-right"
                                            onClick={this.getPayment}>
                                        Ödeme Yap
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(this.state.connectorNewPayments && this.state.connectorNewPayments.length > 0) &&
                        <Col sm="12" style={{
                            paddingBottom: "10px",
                            marginTop: "10px",
                            border: "2px solid #e7e7e7",
                            borderRadius: "6px 6px 6px 6px"
                        }}>
                            <h6 style={{marginLeft: "10px", marginTop: "10px", textTransform: "none"}}>Ödeme Takibi</h6>
                            <Accordion>
                                {this.state.connectorNewPayments.map((item, index) => {
                                    return (
                                        <AccordionItem key={"accordion-item-" + index}>
                                            <AccordionItemTitle
                                                style={{border: this.getStatusColor(item.paymentStatus)}}>
                                                <div className='col-sm-12 row'>
                                                    <div className="accordion__arrow" role="presentation"/>
                                                    <div className='col-sm-6 row'>
                                                        <h6 className="u-position-relative"
                                                            style={{
                                                                margin: "0px",
                                                                marginLeft: "10px",
                                                                textTransform: "none"
                                                            }}>{(index + 1) + ". Ödenecek Tutar: " + item.totalAmount + '₺'}
                                                        </h6>
                                                    </div>
                                                    <div className='col-sm-6 row' style={{paddingLeft: '45px'}}>
                                                        {this.getStatusText(item)}
                                                    </div>
                                                </div>
                                            </AccordionItemTitle>
                                            <AccordionItemBody>
                                                <Alert2 style={{
                                                    backgroundColor: this.paymentAlertColor(item),
                                                    borderColor: "#f5c6cb",
                                                    color: "#155724",
                                                    padding: "8px"
                                                }}>
                                                    <h4 className="alert-heading">
                                                        {item.paymentStatus === 2 &&
                                                            <div className="col-sm-12">
                                                                Başlangıç - Bitiş :<p
                                                                style={{float: "right"}}>{item.startDate ? moment(item.startDate).format("DD-MM-YYYY") : ""} - {item.expireDate ? moment(item.expireDate).format("DD-MM-YYYY") : ""}</p>
                                                            </div>
                                                        }
                                                    </h4>
                                                    <div className="col-sm-12">
                                                        <table className="" style={{textAlign: 'center'}}>
                                                            <thead>
                                                            {connectorPayments && connectorPayments.filter(row => row.connectorNewPaymentId === item.recordId)
                                                                .map((row, i) => {
                                                                    return (
                                                                        <tr style={{backgroundColor: '#ebedf0'}}>
                                                                            <th width="2%">#</th>
                                                                            <th width="18%">Şube Adı</th>
                                                                            <th width="18%">Konnektör Türü</th>
                                                                            {row.fatura && <th width="10%">E-Fatura / E-Arşiv</th>}
                                                                            {row.eirsaliye && <th width="10%">E-Irsaliye</th>}
                                                                            {row.emm && <th width="10%">E-MM</th>}
                                                                            {row.smm && <th width="10%">SMM</th>}
                                                                            {row.defter && <th width="10%">E-Defter</th>}
                                                                            {row.muhasebe && <th width="10%">E-Muhasebe</th>}
                                                                            {row.sigorta && <th width="10%">E-Sigorta</th>}
                                                                            {row.updatedValue && <th width="10%">Güncelleme Ücreti</th>}
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                            </thead>
                                                            <tbody>
                                                            {connectorPayments && connectorPayments.filter(row => row.connectorNewPaymentId === item.recordId)
                                                                .map((row, i) => {
                                                                    return (
                                                                        <tr key={"connectorNewPayment_" + i}>
                                                                            <td>{i + 1}</td>
                                                                            <td>
                                                                            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                                                                    <Input
                                                                                        id={'customerBranchId_' + i}
                                                                                        type="text"
                                                                                        data-vlength="1,255"
                                                                                        className="form-control"
                                                                                        style={{width: "115px", textAlign: "center", padding: "8px"}}
                                                                                        disabled={true}
                                                                                        value={row.customerBranchId && this.getBranchName(row.customerBranchId) ? this.getBranchName(row.customerBranchId).label : ''}
                                                                                        onChange={(e) =>
                                                                                            this.onChange({
                                                                                                value: e.value,
                                                                                                name: "customerBranchId"
                                                                                            }, i)}/>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                                                                    <Select id={'connectorType_' + index}
                                                                                            name={"connectorType"}
                                                                                            disabled={true}
                                                                                            value={row.erpType ? this.getConnectorType(row.erpType) : null}
                                                                                            clearable={false}
                                                                                            noResultsText="Sonuç bulunmadı"
                                                                                            placeholder="Konnektör Türü Seçiniz..."
                                                                                            style={{width: "165px"}}
                                                                                            ref={'connectorType_' + index}
                                                                                            onChange={(e) => this.onChange({
                                                                                                value: e.value,
                                                                                                name: "connectorType"
                                                                                            }, index)}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            {row.fatura &&
                                                                            <td>
                                                                                <input type="checkbox"
                                                                                       id="fatura"
                                                                                       disabled
                                                                                       name={"fatura"}
                                                                                       bssize={"12px"}
                                                                                       style={{margin: "8px"}}
                                                                                       checked={row.fatura}
                                                                                       onChange={(e) => this.onChangeCheck(i, e)}/>
                                                                            </td>
                                                                            }
                                                                            {row.eirsaliye &&
                                                                            <td>
                                                                                <Input type="checkbox"
                                                                                       id="eirsaliye"
                                                                                       name={"eirsaliye"}
                                                                                       disabled
                                                                                       bssize={"12px"}
                                                                                       style={{margin: "8px"}}
                                                                                       checked={row.eirsaliye}
                                                                                       onChange={(e) => this.onChangeCheck(i, e)}/>
                                                                            </td>
                                                                            }
                                                                            {row.emm &&
                                                                            <td>
                                                                                <Input type="checkbox"
                                                                                       id="emm"
                                                                                       name={"emm"}
                                                                                       disabled
                                                                                       bssize={"12px"}
                                                                                       style={{margin: "8px"}}
                                                                                       checked={row.emm}
                                                                                       onChange={(e) => this.onChangeCheck(i, e)}/>
                                                                            </td>
                                                                            }
                                                                            {row.smm &&
                                                                                <td>
                                                                                    <Input type="checkbox"
                                                                                           id="smm"
                                                                                           name={"smm"}
                                                                                           disabled
                                                                                           bssize={"12px"}
                                                                                           style={{margin: "8px"}}
                                                                                           checked={row.smm}
                                                                                           onChange={(e) => this.onChangeCheck(i, e)}/>
                                                                                </td>
                                                                            }
                                                                            {row.defter &&
                                                                                <td>
                                                                                    <Input type="checkbox"
                                                                                           id="defter"
                                                                                           name={"defter"}
                                                                                           disabled
                                                                                           bssize={"12px"}
                                                                                           style={{margin: "8px"}}
                                                                                           checked={row.defter}
                                                                                           onChange={(e) => this.onChangeCheck(i, e)}/>
                                                                                </td>
                                                                            }
                                                                            {row.muhasebe &&
                                                                            <td>
                                                                                <input type="checkbox"
                                                                                       id="muhasebe"
                                                                                       name={"muhasebe"}
                                                                                       disabled
                                                                                       bssize={"12px"}
                                                                                       style={{margin: "8px"}}
                                                                                       checked={row.muhasebe}
                                                                                       onChange={(e) => this.onChangeCheck(i, e)}/>
                                                                            </td>
                                                                            }
                                                                            {row.sigorta &&
                                                                            <td>
                                                                                <input type="checkbox"
                                                                                       id="sigorta"
                                                                                       name={"sigorta"}
                                                                                       disabled
                                                                                       bssize={"12px"}
                                                                                       style={{margin: "8px"}}
                                                                                       checked={row.sigorta}
                                                                                       onChange={(e) => this.onChangeCheck(i, e)}/>
                                                                            </td>
                                                                            }
                                                                            {row.updatedValue &&
                                                                                <td>
                                                                                    <input type="checkbox"
                                                                                           id="updatedValue"
                                                                                           name={"updatedValue"}
                                                                                           disabled
                                                                                           bssize={"12px"}
                                                                                           style={{margin: "8px"}}
                                                                                           checked={row.updatedValue}
                                                                                           onChange={(e) => this.onChangeCheck(i, e)}/>
                                                                                </td>
                                                                            }
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </Alert2>

                                                <div style={{margin: '0 0 16px 0'}}>
                                                    <Col sm="12" style={{padding: '0px'}}>
                                                        <p style={{float: "right", padding: '0px'}}>Toplam
                                                            Tutar: {item.totalAmount} ₺</p>
                                                    </Col>
                                                </div>
                                            </AccordionItemBody>
                                        </AccordionItem>)
                                })
                                }
                            </Accordion>
                        </Col>
                    }
                </Col>
            </DefaultModal>
        );
    }
}

export default ConnectorPaymentModal;